/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BusinessCustomerDto } from '../models';
// @ts-ignore
import type { ContactSearchResponseDto } from '../models';
// @ts-ignore
import type { CreateBusinessCustomerRequestDto } from '../models';
// @ts-ignore
import type { CreateForeignBusinessCustomerRequestDto } from '../models';
// @ts-ignore
import type { CreateIndividualCustomerRequestDto } from '../models';
// @ts-ignore
import type { CustomerCreationResponseDto } from '../models';
// @ts-ignore
import type { CustomerDuplicateResponseDto } from '../models';
// @ts-ignore
import type { CustomerSearchResponseDto } from '../models';
// @ts-ignore
import type { CustomerTypeDto } from '../models';
// @ts-ignore
import type { CustomerTypeResponseDto } from '../models';
// @ts-ignore
import type { ForeignBusinessCustomerDto } from '../models';
// @ts-ignore
import type { GetBusinessCustomerResponseDto } from '../models';
// @ts-ignore
import type { GetForeignBusinessCustomerResponseDto } from '../models';
// @ts-ignore
import type { GetIndividualCustomerResponseDto } from '../models';
// @ts-ignore
import type { IndividualCustomerDto } from '../models';
// @ts-ignore
import type { SearchCustomerContactsRequestDto } from '../models';
// @ts-ignore
import type { SearchCustomersRequestDto } from '../models';
/**
 * RestCustomersApi - axios parameter creator
 */
export const RestCustomersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add contact to customer
         * @param {number} customerId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCustomerContact: async (customerId: number, contactId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('addCustomerContact', 'customerId', customerId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('addCustomerContact', 'contactId', contactId)
            const localVarPath = `/api/customers/{customerId}/contacts/{contactId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{contactId}', encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateBusinessCustomerRequestDto} createBusinessCustomerRequestDto Create customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBusinessCustomer: async (createBusinessCustomerRequestDto: CreateBusinessCustomerRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBusinessCustomerRequestDto' is not null or undefined
            assertParamExists('createBusinessCustomer', 'createBusinessCustomerRequestDto', createBusinessCustomerRequestDto)
            const localVarPath = `/api/business-customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBusinessCustomerRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateForeignBusinessCustomerRequestDto} createForeignBusinessCustomerRequestDto Create foreign customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createForeignBusinessCustomer: async (createForeignBusinessCustomerRequestDto: CreateForeignBusinessCustomerRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createForeignBusinessCustomerRequestDto' is not null or undefined
            assertParamExists('createForeignBusinessCustomer', 'createForeignBusinessCustomerRequestDto', createForeignBusinessCustomerRequestDto)
            const localVarPath = `/api/foreign-business-customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createForeignBusinessCustomerRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateIndividualCustomerRequestDto} createIndividualCustomerRequestDto Create customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIndividualCustomer: async (createIndividualCustomerRequestDto: CreateIndividualCustomerRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createIndividualCustomerRequestDto' is not null or undefined
            assertParamExists('createIndividualCustomer', 'createIndividualCustomerRequestDto', createIndividualCustomerRequestDto)
            const localVarPath = `/api/individual-customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createIndividualCustomerRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete contact from customer
         * @param {number} customerId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerContact: async (customerId: number, contactId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteCustomerContact', 'customerId', customerId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('deleteCustomerContact', 'contactId', contactId)
            const localVarPath = `/api/customers/{customerId}/contacts/{contactId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{contactId}', encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find the customer that would block creating a new one with the given data
         * @param {string} name 
         * @param {CustomerTypeDto} type 
         * @param {string} [distinguishingLabel] 
         * @param {string} [nip] 
         * @param {string} [regon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCustomerDuplicate: async (name: string, type: CustomerTypeDto, distinguishingLabel?: string, nip?: string, regon?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('findCustomerDuplicate', 'name', name)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('findCustomerDuplicate', 'type', type)
            const localVarPath = `/api/customers/duplicate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (distinguishingLabel !== undefined) {
                localVarQueryParameter['distinguishingLabel'] = distinguishingLabel;
            }

            if (nip !== undefined) {
                localVarQueryParameter['nip'] = nip;
            }

            if (regon !== undefined) {
                localVarQueryParameter['regon'] = regon;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBusinessCustomer: async (customerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getBusinessCustomer', 'customerId', customerId)
            const localVarPath = `/api/business-customers/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerType: async (customerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomerType', 'customerId', customerId)
            const localVarPath = `/api/business-customers/{customerId}/type`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForeignBusinessCustomer: async (customerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getForeignBusinessCustomer', 'customerId', customerId)
            const localVarPath = `/api/foreign-business-customers/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndividualCustomer: async (customerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getIndividualCustomer', 'customerId', customerId)
            const localVarPath = `/api/individual-customers/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of customers contacts
         * @param {number} page 
         * @param {number} pageSize 
         * @param {number} customerId 
         * @param {SearchCustomerContactsRequestDto} searchCustomerContactsRequestDto Customer contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCustomerContacts: async (page: number, pageSize: number, customerId: number, searchCustomerContactsRequestDto: SearchCustomerContactsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchCustomerContacts', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchCustomerContacts', 'pageSize', pageSize)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('searchCustomerContacts', 'customerId', customerId)
            // verify required parameter 'searchCustomerContactsRequestDto' is not null or undefined
            assertParamExists('searchCustomerContacts', 'searchCustomerContactsRequestDto', searchCustomerContactsRequestDto)
            const localVarPath = `/api/customers/{customerId}/contacts-search`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchCustomerContactsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of customers
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SearchCustomersRequestDto} searchCustomersRequestDto Customer search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCustomers: async (page: number, pageSize: number, searchCustomersRequestDto: SearchCustomersRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchCustomers', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchCustomers', 'pageSize', pageSize)
            // verify required parameter 'searchCustomersRequestDto' is not null or undefined
            assertParamExists('searchCustomers', 'searchCustomersRequestDto', searchCustomersRequestDto)
            const localVarPath = `/api/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchCustomersRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} customerId 
         * @param {BusinessCustomerDto} businessCustomerDto Update business customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBusinessCustomer: async (customerId: number, businessCustomerDto: BusinessCustomerDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('updateBusinessCustomer', 'customerId', customerId)
            // verify required parameter 'businessCustomerDto' is not null or undefined
            assertParamExists('updateBusinessCustomer', 'businessCustomerDto', businessCustomerDto)
            const localVarPath = `/api/business-customers/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(businessCustomerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} customerId 
         * @param {ForeignBusinessCustomerDto} foreignBusinessCustomerDto Update foreign business customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateForeignBusinessCustomer: async (customerId: number, foreignBusinessCustomerDto: ForeignBusinessCustomerDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('updateForeignBusinessCustomer', 'customerId', customerId)
            // verify required parameter 'foreignBusinessCustomerDto' is not null or undefined
            assertParamExists('updateForeignBusinessCustomer', 'foreignBusinessCustomerDto', foreignBusinessCustomerDto)
            const localVarPath = `/api/foreign-business-customers/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(foreignBusinessCustomerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} customerId 
         * @param {IndividualCustomerDto} individualCustomerDto Update customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIndividualCustomer: async (customerId: number, individualCustomerDto: IndividualCustomerDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('updateIndividualCustomer', 'customerId', customerId)
            // verify required parameter 'individualCustomerDto' is not null or undefined
            assertParamExists('updateIndividualCustomer', 'individualCustomerDto', individualCustomerDto)
            const localVarPath = `/api/individual-customers/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(individualCustomerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestCustomersApi - functional programming interface
 */
export const RestCustomersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestCustomersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add contact to customer
         * @param {number} customerId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCustomerContact(customerId: number, contactId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCustomerContact(customerId, contactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.addCustomerContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateBusinessCustomerRequestDto} createBusinessCustomerRequestDto Create customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBusinessCustomer(createBusinessCustomerRequestDto: CreateBusinessCustomerRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerCreationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBusinessCustomer(createBusinessCustomerRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.createBusinessCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateForeignBusinessCustomerRequestDto} createForeignBusinessCustomerRequestDto Create foreign customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createForeignBusinessCustomer(createForeignBusinessCustomerRequestDto: CreateForeignBusinessCustomerRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerCreationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createForeignBusinessCustomer(createForeignBusinessCustomerRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.createForeignBusinessCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateIndividualCustomerRequestDto} createIndividualCustomerRequestDto Create customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIndividualCustomer(createIndividualCustomerRequestDto: CreateIndividualCustomerRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerCreationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIndividualCustomer(createIndividualCustomerRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.createIndividualCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete contact from customer
         * @param {number} customerId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomerContact(customerId: number, contactId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomerContact(customerId, contactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.deleteCustomerContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Find the customer that would block creating a new one with the given data
         * @param {string} name 
         * @param {CustomerTypeDto} type 
         * @param {string} [distinguishingLabel] 
         * @param {string} [nip] 
         * @param {string} [regon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findCustomerDuplicate(name: string, type: CustomerTypeDto, distinguishingLabel?: string, nip?: string, regon?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDuplicateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findCustomerDuplicate(name, type, distinguishingLabel, nip, regon, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.findCustomerDuplicate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBusinessCustomer(customerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBusinessCustomerResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBusinessCustomer(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.getBusinessCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerType(customerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerTypeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerType(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.getCustomerType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForeignBusinessCustomer(customerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetForeignBusinessCustomerResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForeignBusinessCustomer(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.getForeignBusinessCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIndividualCustomer(customerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIndividualCustomerResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIndividualCustomer(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.getIndividualCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of customers contacts
         * @param {number} page 
         * @param {number} pageSize 
         * @param {number} customerId 
         * @param {SearchCustomerContactsRequestDto} searchCustomerContactsRequestDto Customer contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCustomerContacts(page: number, pageSize: number, customerId: number, searchCustomerContactsRequestDto: SearchCustomerContactsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCustomerContacts(page, pageSize, customerId, searchCustomerContactsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.searchCustomerContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of customers
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SearchCustomersRequestDto} searchCustomersRequestDto Customer search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCustomers(page: number, pageSize: number, searchCustomersRequestDto: SearchCustomersRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCustomers(page, pageSize, searchCustomersRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.searchCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} customerId 
         * @param {BusinessCustomerDto} businessCustomerDto Update business customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBusinessCustomer(customerId: number, businessCustomerDto: BusinessCustomerDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBusinessCustomer(customerId, businessCustomerDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.updateBusinessCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} customerId 
         * @param {ForeignBusinessCustomerDto} foreignBusinessCustomerDto Update foreign business customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateForeignBusinessCustomer(customerId: number, foreignBusinessCustomerDto: ForeignBusinessCustomerDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateForeignBusinessCustomer(customerId, foreignBusinessCustomerDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.updateForeignBusinessCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} customerId 
         * @param {IndividualCustomerDto} individualCustomerDto Update customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIndividualCustomer(customerId: number, individualCustomerDto: IndividualCustomerDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIndividualCustomer(customerId, individualCustomerDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCustomersApi.updateIndividualCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestCustomersApi - factory interface
 */
export const RestCustomersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestCustomersApiFp(configuration)
    return {
        /**
         * 
         * @summary Add contact to customer
         * @param {number} customerId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCustomerContact(customerId: number, contactId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addCustomerContact(customerId, contactId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateBusinessCustomerRequestDto} createBusinessCustomerRequestDto Create customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBusinessCustomer(createBusinessCustomerRequestDto: CreateBusinessCustomerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CustomerCreationResponseDto> {
            return localVarFp.createBusinessCustomer(createBusinessCustomerRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateForeignBusinessCustomerRequestDto} createForeignBusinessCustomerRequestDto Create foreign customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createForeignBusinessCustomer(createForeignBusinessCustomerRequestDto: CreateForeignBusinessCustomerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CustomerCreationResponseDto> {
            return localVarFp.createForeignBusinessCustomer(createForeignBusinessCustomerRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateIndividualCustomerRequestDto} createIndividualCustomerRequestDto Create customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIndividualCustomer(createIndividualCustomerRequestDto: CreateIndividualCustomerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CustomerCreationResponseDto> {
            return localVarFp.createIndividualCustomer(createIndividualCustomerRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete contact from customer
         * @param {number} customerId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerContact(customerId: number, contactId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCustomerContact(customerId, contactId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find the customer that would block creating a new one with the given data
         * @param {string} name 
         * @param {CustomerTypeDto} type 
         * @param {string} [distinguishingLabel] 
         * @param {string} [nip] 
         * @param {string} [regon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCustomerDuplicate(name: string, type: CustomerTypeDto, distinguishingLabel?: string, nip?: string, regon?: string, options?: RawAxiosRequestConfig): AxiosPromise<CustomerDuplicateResponseDto> {
            return localVarFp.findCustomerDuplicate(name, type, distinguishingLabel, nip, regon, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBusinessCustomer(customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetBusinessCustomerResponseDto> {
            return localVarFp.getBusinessCustomer(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerType(customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<CustomerTypeResponseDto> {
            return localVarFp.getCustomerType(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForeignBusinessCustomer(customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetForeignBusinessCustomerResponseDto> {
            return localVarFp.getForeignBusinessCustomer(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndividualCustomer(customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetIndividualCustomerResponseDto> {
            return localVarFp.getIndividualCustomer(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of customers contacts
         * @param {number} page 
         * @param {number} pageSize 
         * @param {number} customerId 
         * @param {SearchCustomerContactsRequestDto} searchCustomerContactsRequestDto Customer contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCustomerContacts(page: number, pageSize: number, customerId: number, searchCustomerContactsRequestDto: SearchCustomerContactsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ContactSearchResponseDto> {
            return localVarFp.searchCustomerContacts(page, pageSize, customerId, searchCustomerContactsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of customers
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SearchCustomersRequestDto} searchCustomersRequestDto Customer search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCustomers(page: number, pageSize: number, searchCustomersRequestDto: SearchCustomersRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CustomerSearchResponseDto> {
            return localVarFp.searchCustomers(page, pageSize, searchCustomersRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} customerId 
         * @param {BusinessCustomerDto} businessCustomerDto Update business customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBusinessCustomer(customerId: number, businessCustomerDto: BusinessCustomerDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateBusinessCustomer(customerId, businessCustomerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} customerId 
         * @param {ForeignBusinessCustomerDto} foreignBusinessCustomerDto Update foreign business customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateForeignBusinessCustomer(customerId: number, foreignBusinessCustomerDto: ForeignBusinessCustomerDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateForeignBusinessCustomer(customerId, foreignBusinessCustomerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} customerId 
         * @param {IndividualCustomerDto} individualCustomerDto Update customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIndividualCustomer(customerId: number, individualCustomerDto: IndividualCustomerDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateIndividualCustomer(customerId, individualCustomerDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestCustomersApi - interface
 */
export interface RestCustomersApiInterface {
    /**
     * 
     * @summary Add contact to customer
     * @param {number} customerId 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addCustomerContact(customerId: number, contactId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {CreateBusinessCustomerRequestDto} createBusinessCustomerRequestDto Create customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createBusinessCustomer(createBusinessCustomerRequestDto: CreateBusinessCustomerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CustomerCreationResponseDto>;

    /**
     * 
     * @param {CreateForeignBusinessCustomerRequestDto} createForeignBusinessCustomerRequestDto Create foreign customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createForeignBusinessCustomer(createForeignBusinessCustomerRequestDto: CreateForeignBusinessCustomerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CustomerCreationResponseDto>;

    /**
     * 
     * @param {CreateIndividualCustomerRequestDto} createIndividualCustomerRequestDto Create customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createIndividualCustomer(createIndividualCustomerRequestDto: CreateIndividualCustomerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CustomerCreationResponseDto>;

    /**
     * 
     * @summary Delete contact from customer
     * @param {number} customerId 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCustomerContact(customerId: number, contactId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Find the customer that would block creating a new one with the given data
     * @param {string} name 
     * @param {CustomerTypeDto} type 
     * @param {string} [distinguishingLabel] 
     * @param {string} [nip] 
     * @param {string} [regon] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findCustomerDuplicate(name: string, type: CustomerTypeDto, distinguishingLabel?: string, nip?: string, regon?: string, options?: RawAxiosRequestConfig): AxiosPromise<CustomerDuplicateResponseDto>;

    /**
     * 
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBusinessCustomer(customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetBusinessCustomerResponseDto>;

    /**
     * 
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerType(customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<CustomerTypeResponseDto>;

    /**
     * 
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getForeignBusinessCustomer(customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetForeignBusinessCustomerResponseDto>;

    /**
     * 
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIndividualCustomer(customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetIndividualCustomerResponseDto>;

    /**
     * 
     * @summary Get list of customers contacts
     * @param {number} page 
     * @param {number} pageSize 
     * @param {number} customerId 
     * @param {SearchCustomerContactsRequestDto} searchCustomerContactsRequestDto Customer contacts search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchCustomerContacts(page: number, pageSize: number, customerId: number, searchCustomerContactsRequestDto: SearchCustomerContactsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ContactSearchResponseDto>;

    /**
     * 
     * @summary Get list of customers
     * @param {number} page 
     * @param {number} pageSize 
     * @param {SearchCustomersRequestDto} searchCustomersRequestDto Customer search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchCustomers(page: number, pageSize: number, searchCustomersRequestDto: SearchCustomersRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CustomerSearchResponseDto>;

    /**
     * 
     * @param {number} customerId 
     * @param {BusinessCustomerDto} businessCustomerDto Update business customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBusinessCustomer(customerId: number, businessCustomerDto: BusinessCustomerDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {number} customerId 
     * @param {ForeignBusinessCustomerDto} foreignBusinessCustomerDto Update foreign business customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateForeignBusinessCustomer(customerId: number, foreignBusinessCustomerDto: ForeignBusinessCustomerDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {number} customerId 
     * @param {IndividualCustomerDto} individualCustomerDto Update customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIndividualCustomer(customerId: number, individualCustomerDto: IndividualCustomerDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestCustomersApi - object-oriented interface
 */
export class RestCustomersApi extends BaseAPI implements RestCustomersApiInterface {
    /**
     * 
     * @summary Add contact to customer
     * @param {number} customerId 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addCustomerContact(customerId: number, contactId: number, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).addCustomerContact(customerId, contactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateBusinessCustomerRequestDto} createBusinessCustomerRequestDto Create customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createBusinessCustomer(createBusinessCustomerRequestDto: CreateBusinessCustomerRequestDto, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).createBusinessCustomer(createBusinessCustomerRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateForeignBusinessCustomerRequestDto} createForeignBusinessCustomerRequestDto Create foreign customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createForeignBusinessCustomer(createForeignBusinessCustomerRequestDto: CreateForeignBusinessCustomerRequestDto, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).createForeignBusinessCustomer(createForeignBusinessCustomerRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateIndividualCustomerRequestDto} createIndividualCustomerRequestDto Create customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createIndividualCustomer(createIndividualCustomerRequestDto: CreateIndividualCustomerRequestDto, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).createIndividualCustomer(createIndividualCustomerRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete contact from customer
     * @param {number} customerId 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCustomerContact(customerId: number, contactId: number, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).deleteCustomerContact(customerId, contactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find the customer that would block creating a new one with the given data
     * @param {string} name 
     * @param {CustomerTypeDto} type 
     * @param {string} [distinguishingLabel] 
     * @param {string} [nip] 
     * @param {string} [regon] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findCustomerDuplicate(name: string, type: CustomerTypeDto, distinguishingLabel?: string, nip?: string, regon?: string, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).findCustomerDuplicate(name, type, distinguishingLabel, nip, regon, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBusinessCustomer(customerId: number, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).getBusinessCustomer(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomerType(customerId: number, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).getCustomerType(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getForeignBusinessCustomer(customerId: number, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).getForeignBusinessCustomer(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getIndividualCustomer(customerId: number, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).getIndividualCustomer(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of customers contacts
     * @param {number} page 
     * @param {number} pageSize 
     * @param {number} customerId 
     * @param {SearchCustomerContactsRequestDto} searchCustomerContactsRequestDto Customer contacts search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchCustomerContacts(page: number, pageSize: number, customerId: number, searchCustomerContactsRequestDto: SearchCustomerContactsRequestDto, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).searchCustomerContacts(page, pageSize, customerId, searchCustomerContactsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of customers
     * @param {number} page 
     * @param {number} pageSize 
     * @param {SearchCustomersRequestDto} searchCustomersRequestDto Customer search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchCustomers(page: number, pageSize: number, searchCustomersRequestDto: SearchCustomersRequestDto, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).searchCustomers(page, pageSize, searchCustomersRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} customerId 
     * @param {BusinessCustomerDto} businessCustomerDto Update business customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateBusinessCustomer(customerId: number, businessCustomerDto: BusinessCustomerDto, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).updateBusinessCustomer(customerId, businessCustomerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} customerId 
     * @param {ForeignBusinessCustomerDto} foreignBusinessCustomerDto Update foreign business customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateForeignBusinessCustomer(customerId: number, foreignBusinessCustomerDto: ForeignBusinessCustomerDto, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).updateForeignBusinessCustomer(customerId, foreignBusinessCustomerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} customerId 
     * @param {IndividualCustomerDto} individualCustomerDto Update customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateIndividualCustomer(customerId: number, individualCustomerDto: IndividualCustomerDto, options?: RawAxiosRequestConfig) {
        return RestCustomersApiFp(this.configuration).updateIndividualCustomer(customerId, individualCustomerDto, options).then((request) => request(this.axios, this.basePath));
    }
}

